import { CourseId } from 'modules/courses/courses/types/course-interface'
import { StudentInterface } from 'modules/courses/students/types/student-interface'
import httpClient from 'shared/utils/http-client'
import { CreateStudentApiInterface } from 'modules/courses/courses/curriculum/types/student-interface'
import { COURSE_API } from 'modules/courses/courses/curriculum/api/course-curriculum-api'

export const addStudent = (id: CourseId, data: CreateStudentApiInterface) =>
  httpClient.post<StudentInterface>(`${COURSE_API}/${id}/enrollment`, data)
